import { Controller } from "@hotwired/stimulus";

// Wires the "List models" buttons to POST /api/settings/models — with the
// key typed next to them when there is one, so a key can be verified before
// it is saved — and fills a <datalist> each agent model field autocompletes
// against for its provider. Fields stay free-text: a catalogue is an offering,
// not a constraint.
export default class ModelPickerController extends Controller {
  static values = { url: String };

  connect() {
    this.models = {};
    // Provider selects pair with model inputs by id convention
    // (agents_<name>_provider / agents_<name>_model), set in settings.html.
    this.element.querySelectorAll('select[id$="_provider"]').forEach((sel) => {
      const input = document.getElementById(sel.id.replace(/_provider$/, "_model"));
      if (!input) return;
      const sync = () => input.setAttribute("list", `model-options-${sel.value}`);
      sel.addEventListener("change", sync);
      sync();
    });
  }

  async load(event) {
    const btn = event.currentTarget;
    const source = btn.dataset.modelsSource;
    const status = this.element.querySelector(`[data-models-status="${source}"]`);
    const keyInput = document.getElementById(btn.dataset.modelsKeyInput);
    const baseInput = document.getElementById(btn.dataset.modelsBaseInput);
    const apiKey = keyInput ? keyInput.value.trim() : "";
    const baseUrl = baseInput ? baseInput.value.trim() : "";

    btn.disabled = true;
    this.setStatus(status, "fetching…", "var(--dim)");
    try {
      const res = await fetch(this.urlValue, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ source, api_key: apiKey, base_url: baseUrl }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
      this.models[source] = data.models || [];
      this.render(source);
      this.setStatus(status, `${this.models[source].length} models — model fields now autocomplete`, "var(--accent)");
    } catch (err) {
      this.setStatus(status, err.message, "#fca5a5");
    } finally {
      btn.disabled = false;
    }
  }

  // Each source fills its own datalist.
  render(source) {
    this.listFor(source).replaceChildren(...toOptions(this.models[source]));
  }

  listFor(source) {
    let dl = document.getElementById(`model-options-${source}`);
    if (!dl) {
      dl = document.createElement("datalist");
      dl.id = `model-options-${source}`;
      document.body.appendChild(dl);
    }
    return dl;
  }

  setStatus(el, text, color) {
    if (!el) return;
    el.textContent = text;
    el.style.color = color;
  }
}

function toOptions(models) {
  return models.map((m) => {
    const opt = document.createElement("option");
    opt.value = m.id;
    // Browsers match the filter against the value and the text alike.
    if (m.name && m.name !== m.id) opt.textContent = m.name;
    return opt;
  });
}
